// Copied verbatim from tab-portal src/lib/name-identification (qa c50f5268), the portal mirror of
// core-api src/utils/nameIdentification. Rules only: no AI pass. Keep the three in step.
import { PERSON_SUFFIXES } from './constants'

/** Collapse whitespace; preserve meaningful punctuation. */
export const normalizeName = (raw: string | null | undefined): string =>
  String(raw ?? '')
    .trim()
    .replace(/\s+/g, ' ')

/** Stable key for nameResolution maps (case-insensitive). */
export const normalizeNameKey = (raw: string | null | undefined): string =>
  normalizeName(raw).toUpperCase()

export const tokenize = (raw: string): string[] => {
  const normalized = normalizeName(raw)
  if (!normalized) return []
  return normalized.split(' ').filter(Boolean)
}

export const isSingleLetterToken = (token: string): boolean =>
  /^[A-Z]\.?$/.test(token.toUpperCase())

export const stripTrailingPersonSuffix = (
  tokens: string[],
): { tokens: string[]; suffix: string } => {
  if (tokens.length === 0) return { tokens, suffix: '' }
  const last = tokens[tokens.length - 1].toUpperCase().replace(/\./g, '')
  if (PERSON_SUFFIXES.has(last)) {
    return {
      tokens: tokens.slice(0, -1),
      suffix: tokens[tokens.length - 1],
    }
  }
  return { tokens, suffix: '' }
}

/** Detect trailing parenthetical e.g. "(THE)" for business line 2. */
export const extractTrailingParenthetical = (
  raw: string,
): { main: string; parenthetical: string } => {
  const match = raw.trim().match(/^(.*)\s(\([^)]+\))\s*$/)
  if (!match) return { main: raw.trim(), parenthetical: '' }
  return { main: match[1].trim(), parenthetical: match[2].trim() }
}

export const hasDigitInToken = (token: string): boolean => /\d/.test(token)

export const isHyphenatedSurnameToken = (token: string): boolean =>
  token.includes('-') && /^[A-Z][A-Z-]+$/i.test(token)
